import { OccupancyState } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { Tag, TagVariant } from '@optimus-web/core';

interface ResourceOccupancyStateTagProps {
    occupancyState: OccupancyState;
}

const occupancyStateTextKeyMap = {
    [OccupancyState.Vacant]: TextKey.Vacant,
    [OccupancyState.ReservedLocked]: TextKey.ReservedLocked,
    [OccupancyState.Reserved]: TextKey.Reserved,
    [OccupancyState.InternalUse]: TextKey.InternalUse,
    [OccupancyState.OutOfOrder]: TextKey.OutOfOrder,
};

const getTagVariantFromResourceOccupancyState = createHandler<OccupancyState, TagVariant>(
    {
        [OccupancyState.Vacant]: 'lime',
        [OccupancyState.ReservedLocked]: 'tangerine',
        [OccupancyState.Reserved]: 'basicBold',
        [OccupancyState.InternalUse]: 'lavender',
        [OccupancyState.OutOfOrder]: 'mustard',
    },
    'basicBold'
);

const ResourceOccupancyStateTag = ({ occupancyState }: ResourceOccupancyStateTagProps) => {
    const tagVariant = getTagVariantFromResourceOccupancyState(occupancyState);

    return (
        <Tag variant={tagVariant}>
            <LocalizedText textKey={occupancyStateTextKeyMap[occupancyState]} />
        </Tag>
    );
};

export default ResourceOccupancyStateTag;
